import React, { useCallback } from "react";
import "./NotificationList.css";
import { useDataContext } from "../../../data-context/DataContextProvider";
import { useTranslation, TranslationKey } from "@preppa/translation";
//SKAPA Components
import ListView, { ListViewItem } from "@ingka/list-view";
import Button from "@ingka/button";
//SKAPA Icons
//SKAPA Styles
import "@ingka/svg-icon/dist/style.css";
import "@ingka/aspect-ratio-box/dist/style.css";
import "@ingka/image/dist/style.css";
import "@ingka/text/dist/style.css";
import "@ingka/switch/dist/style.css";
import "@ingka/forms/dist/style.css";
import "@ingka/list-view/dist/style.css";
import "@ingka/focus/dist/style.css";

const MONTH_KEYS: TranslationKey[] = [
  "months.jan", "months.feb", "months.mar", "months.apr",
  "months.may", "months.jun", "months.jul", "months.aug",
  "months.sep", "months.oct", "months.nov", "months.dec"
];

function NotificationList() {
  const { notifications, dispatch } = useDataContext();
  const { translate } = useTranslation();

  const formatTimestamp = useCallback((timestamp: Date) => {
    const date = new Date(timestamp);
    const month = translate(MONTH_KEYS[date.getMonth()]);
    const day = date.getDate();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${month} ${day}, ${hours}:${minutes}`;
  }, [translate]);

  return (
    <div className="notification-list-wrapper">
      {notifications.length > 0 && (
        <Button
          className="clear-history-button"
          type="tertiary"
          size="xsmall"
          text={translate("header.clearHistory")}
          onClick={() => dispatch({ type: "CLEAR_NOTIFICATIONS" })}
        />
      )}
      <ListView id="notification-list-view">
        {notifications.length === 0 ? (
          <ListViewItem
            title={translate("header.noNotifications")} /* 
            description={translate("header.noNotificationsDescription")} */
          />
        ) : (
          notifications.map((notification) => (
            <ListViewItem
              key={notification.id}
              title={notification.topic.replace(/_/g, " ")}
              description={`${notification.entityName} (${notification.entityId}) • ${formatTimestamp(notification.timestamp)}`}
            />
          ))
        )}
      </ListView>
    </div>
  );
}

export default NotificationList;
